// extracted by mini-css-extract-plugin
export default {"rectFloatingButton":"RectFloatingButton_rectFloatingButton__hJXqZ"};